import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, Language } from './translations';

export type TOptions = {
  defaultValue?: string;
  returnObjects?: boolean;
  [key: string]: any;
};

type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, options?: TOptions) => any;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// 检测浏览器语言
const detectLanguage = (): Language => {
  const browserLang = navigator.language.toLowerCase();
  return browserLang.startsWith('zh') ? 'zh' : 'en';
};

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>(detectLanguage());

  const t = (key: string, options?: TOptions) => {
    const keys = key.split('.');
    let value: any = translations[language];
    
    for (const k of keys) {
      if (!value || !value[k]) {
        return options?.defaultValue || key;
      }
      value = value[k];
    }
    
    // 如果结果是对象且returnObjects选项不为true，返回警告或键名
    if (typeof value === 'object' && !options?.returnObjects) {
      console.warn(`Translation key "${key}" returned an object. Set returnObjects: true in options to return the object.`);
      return options?.defaultValue || key;
    }
    
    return value;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}; 